import type { PropsWithChildren } from 'react';

import twigPropsContext from './context/TwigPropsContext/TwigPropsContext';

const TwigPropsContextProvider = <T extends object>({
    twigContext,
    children,
}: PropsWithChildren<{ twigContext: T }>) => (
    <twigPropsContext.Provider value={twigContext}>{children}</twigPropsContext.Provider>
);

export default TwigPropsContextProvider;
